import { PublicClientApplication } from "@azure/msal-browser";
import { CobaltThemeProvider } from "@cae/cobalt-react/theme";
import React from "react";

import "./App.css";
import "./cobalt-overrides.css";
import ETcaMFE from "./features/ETcaMFE";
import msalMockData from "./mocks/data/msalMockData";
import userMockData from "./mocks/data/userMockData";
import { User } from "./shared/models/user";

declare global {
  interface Window {
    props?: {
      msalInstance?: PublicClientApplication;
      user?: User;
      geminiId?: string;
      trainingEventId?: string;
    };
  }
}

const msalInstance: PublicClientApplication =
  window.props?.msalInstance ?? msalMockData;

const user: User = window.props?.user ?? userMockData;

const pathSegments = window.location.pathname.split("/").filter(Boolean);
const etcaIndex = pathSegments.findIndex(s => s.toLowerCase() === "etca");
const trainingEventIdFromUrl = etcaIndex !== -1 ? pathSegments[etcaIndex + 1] : pathSegments.pop();
const trainingEventId: string = window.props?.trainingEventId ?? window.props?.geminiId ?? trainingEventIdFromUrl ?? "mock-training-event-id";

function App(): React.JSX.Element {
  const account = msalInstance.getActiveAccount();

  if (account?.username === "mock-username") {
    return (
      <center>
        <h2>Hello, {account.name}!</h2>
      </center>
    );
  }

  return (
    <CobaltThemeProvider initialBrand="default">
      <ETcaMFE msalInstance={msalInstance} user={user} trainingEventId={trainingEventId} permissions={[]} hideSideNavigation={(): void => {}} onNavigateBack={(): void => {}} />
    </CobaltThemeProvider>
  );
}

export default App;
